import i18next from 'i18next'
import HttpApi from 'i18next-http-backend'

export const i18nextPromise = i18next
  .use(HttpApi)
  .init({
    lng: window.appData.locale,
    fallbackLng: 'it',
    debug: window.appData.env == 'development',
    ns: [
      'application',
      'controllers__chats__messages_controller',
      'controllers__draw__form_controller',
      'controllers__import_site_tasks__form_controller',
      'controllers__site_task_measurements__form_controller',
      'controllers__sites__dhtmlx_gantt_show_controller',
      'controllers__utils__form__datetime_picker_controller'
    ],
    defaultNS: 'application',
    backend: {
      loadPath: '/locales/js/{{ns}}/{{lng}}.json'
    },
    load: 'languageOnly',
  })
